import Vue from 'vue'
import jwt from "jsonwebtoken";
import api from "../../plugins/api";

export default {
    namespaced: true,
    state: {
        application: {},
        applications: {},
        signinToken: null,
        signinMethod: "POST",
    },
    actions: {
        getApplication: ({ commit }, appId) => {
            return Vue.http.get('app/' + appId)
                .then(response => { commit("SET_APPLICATION", response.body) })
                .catch(error => { api.error(commit, error) })
        },
        setApplication: ({ commit }, data) => {
            return Vue.http.put('app', { name : data.name, description: data.description, link: data.link } ,{ emulateJSON: true })
                .catch(error => { api.error(commit, error) })
        },
        updateApplicationInfo: ({ commit }, data) => {
            return Vue.http.put('app/' + data.id, { name : data.name, description: data.description, link: data.link } ,{ emulateJSON: true })
                .then(response => { commit("SET_APPLICATION", response.body); api.success(commit, "application mise à jour !") })
                .catch(error => { api.error(commit, error) })
        },
        generateSignInToken: ({ commit }, data) => {
            return Vue.http.post('credentials/app/signin', { app_id: data.app_id, token: data.token }, { emulateJSON: true })
                .then(response => {
                    return commit("SET_SIGNIN_TOKEN", response.body)
                })
                .catch(error => { throw error.body.message })
        },
        updateApplicationDesc: ({ commit }, data) => {
            return Vue.http.put('application/' + data.app_id + '/description', { description: data.description }, { emulateJSON: true })
                .catch(error => { api.error(commit, error) })
        }
    },
    mutations:{
        SET_APPLICATION: (state, data) => {
            return state.application = data
        },
        SET_APPLICATIONS: (state, data) => {
            return state.applications = data
        },
        SET_SIGNIN_TOKEN: (state, data) => {
            state.signinToken = data.token
            if(data.method == 1){
                state.signinMethod = "POST"
            }else{
                state.signinMethod = "GET"
            }
        }
    },
    getters: {
        application: (state) => state.application,
        applications: (state) => state.applications,
        signInToken: (state) => state.signinToken,
        signInMethod: (state) => state.signinMethod
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/application.js